/* eslint-disable complexity */
// Models
import Entity from '../models/entity';

import {
    FETCH_TID_SUCCESS,
    FETCH_TID_ERROR,
    GET_MERCHANT_INFO_SUCCESS,
    GET_TERMINAL_INFO_ERROR,
    GET_TERMINAL_INFO_SUCCESS,
    FETCH_ENTITY_HIERARCHY_ERROR,
    FETCH_ENTITY_HIERARCHY_SUCCESS,
    RESET_TERMINAL_DATA,
    FETCH_STATIC_URL_SUCCESS,
    FETCH_STATIC_URL_ERROR,
    RESET_MERCHANT_DATA,
    RESET_H_LIST,
    FETCH_ENTITY_LIST_MERCHANT_ERROR,
    FETCH_ENTITY_LIST_MERCHANT_SUCCESS,
    SHOW_ENTITY_HIERARCHY_LOADER,
    HIDE_ENTITY_HIERARCHY_LOADER,
    GET_MERCHANT_INFO_ERROR,
    FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST,
} from './TIDOnBoard.constants';

export const initialState = {
    terminalsData: {
        pagination: {},
        merchant: {},
    },
    hList: {},
    hierarchyLoader: 0,
    entityList: {},
    listExecuting: 0,
    tidEditData: {},
    pagination: {},
};

// eslint-disable-next-line max-lines-per-function
export const TIDReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TID_SUCCESS: {
            const createEntity = new Entity(action.payload);
            return { ...state, ...createEntity, error: {} };
        }
        case FETCH_TID_ERROR:
            return {
                ...state,
                error: action.payload,
                tableData: [],
                pagination: {},
            };
        case GET_MERCHANT_INFO_SUCCESS:
            return { ...state, merchant: action.payload };
        case GET_MERCHANT_INFO_ERROR: {
            return { ...state, error: action.payload };
        }
        case GET_TERMINAL_INFO_SUCCESS:
            return { ...state, tidEditData: action.payload, tidError: {} };
        case GET_TERMINAL_INFO_ERROR:
            return { ...state, tidEditData: null, tidError: action.payload };
        case FETCH_ENTITY_HIERARCHY_SUCCESS: {
            return { ...state, hList: action.payload };
        }
        case FETCH_ENTITY_HIERARCHY_ERROR: {
            return { ...state, hListError: action.payload };
        }
        case RESET_H_LIST: {
            return { ...state, hList: {} };
        }
        case RESET_TERMINAL_DATA: {
            return {
                ...state,
                tidEditData: null,
                tidError: {},
                staticQr: null,
            };
        }
        case FETCH_STATIC_URL_SUCCESS: {
            return { ...state, staticQr: action.payload };
        }
        case FETCH_STATIC_URL_ERROR: {
            return { ...state, staticQr: null, staticQrError: action.payload };
        }
        case RESET_MERCHANT_DATA: {
            return { ...state, merchant: null };
        }
        case SHOW_ENTITY_HIERARCHY_LOADER:
            return { ...state, hierarchyLoader: state.hierarchyLoader + 1 };
        case HIDE_ENTITY_HIERARCHY_LOADER:
            return { ...state, hierarchyLoader: state.hierarchyLoader - 1 };
        case FETCH_ENTITY_LIST_MERCHANT_SUCCESS: {
            const entities = { ...state.entityList, ...action.payload };
            return { ...state, entityList: entities };
        }
        case FETCH_ENTITY_LIST_MERCHANT_ERROR: {
            return { ...state, entityList: { ...action.payload } };
        }
        case FETCH_ENTITY_LIST_MERCHANT_SUCCESS_ADD_LIST: {
            const updatedEntities = [
                ...action.payload[action.entityType],
                ...state.entityList[action.entityType],
            ].reduce((acc, item) => {
                if (
                    !acc.some(
                        existing => existing.entityCode === item.entityCode
                    )
                ) {
                    acc.push(item);
                }
                return acc;
            }, []);

            const entities = {
                ...state.entityList,
                [action.entityType]: updatedEntities,
            };

            return {
                ...state,
                entityList: entities,
                listExecuting: state.listExecuting - 1,
            };
        }
        default:
            return state;
    }
};
